import {fromJS} from 'immutable';
import actions from '../actions/eula.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    affiliate: {},
    conduct: {},
    affiliateLoading: false,
    conductLoading: false
});

export const eulaReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actions.TYPES.GET_AFFILIATE_AGREEMENT:
            return state.set('affiliateLoading', true);

        case actions.TYPES.GET_CONDUCT_AGREEMENT:
            return state.set('conductLoading', true);

        case actions.TYPES.GET_AFFILIATE_AGREEMENT_COMPLETE:
            return state.set('affiliateLoading', false).set('affiliate', action.payload);

        case actions.TYPES.GET_CONDUCT_AGREEMENT_COMPLETE:
            return state.set('conductLoading', false).set('conduct', action.payload);

        case actions.TYPES.GET_AFFILIATE_AGREEMENT_FAILED:
            return state.set('affiliateLoading', false);

        case actions.TYPES.GET_CONDUCT_AGREEMENT_FAILED:
            return state.set('conductLoading', false);

        case actions.TYPES.ACCEPT_AGREEMENTS: {
            const affiliate = {...state.get('affiliate'), accepted: true};
            const conduct = {...state.get('conduct'), accepted: true};

            return state.set('affiliate', affiliate).set('conduct', conduct);
        }
        default:
            return state;
    }
};

export default dieselReducer('eula', eulaReducer);
